enum TypePiece {
  SHIPPING = 'Ongkos Kirim',
  OTHER = 'Lainnya'
}

export default TypePiece;
